export const search_list = (type = 1, mini_publish_type = []) => {
  if (type == 1) {
    return [
      // {
      //   type: "select",
      //   label: "发布位置",
      //   props: "publish_type",
      //   selectData: publish_type_list,
      // },
      {
        type: "input",
        label: "资讯标题",
        props: "title",
      },
      {
        type: "date",
        label: "时间",
        props: "date",
      },
    ];
  } else {
    return [
      // {
      //   type: "select",
      //   label: "发布位置",
      //   props: "publish_type",
      //   selectData: publish_type_list,
      // },
      {
        type: "select",
        label: "小程序位置",
        props: "mini_publish_type",
        selectData: mini_publish_type,
      },
      {
        type: "input",
        label: "资讯标题",
        props: "title",
      },
      {
        type: "date",
        label: "时间",
        props: "date",
      },
    ];
  }
};
export const tableColumns = [
  {
    title: "排序",
    value: "sort",
    header_align: "center",
    align: "center",
    width: 80,
  },
  {
    title: "资讯标题",
    value: "title",
    header_align: "center",
    align: "center",
    width: 220,
  },
  {
    title: "资讯内容",
    value: "profile",
    header_align: "center",
    align: "center",
    width: 350,
  },
  {
    title: "首页推荐",
    value: "is_recommend_text",
    header_align: "center",
    align: "center",
    width: 140,
  },
  {
    title: "是否置顶",
    value: "is_top_text",
    header_align: "center",
    align: "center",
    width: 140,
  },
  { title: "创建日期", value: "created_at", header_align: "center", align: "center", width: 200 },
  { title: "浏览量", value: "view_count", header_align: "center", align: "center", width: 120 },
  {
    width: 100,
    title: "公告状态",
    value: "is_display_text",
    header_align: "center",
    align: "center",
  },
];

export const actionGroup = [
  {
    name: "删除",
    is_delete: true,
    flag: "delete",
    status: "danger",
  },
  {
    name: "编辑",
    flag: "edit",
    rules: "",
  },
  {
    name: "详情",
    flag: "detail",
    rules: "",
  },
  {
    name: "同步",
    flag: "resync",
    rules: "",
  },
];
